import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import SEO from '../SEO'; // Import the SEO component
import cinnamonImage from '../assets/about/1.png';
import cinnamonImage2 from '../assets/about/Images/2.jpeg';
import galleryImage1 from '../assets/about/IMG_4260.jpg';
import galleryImage2 from '../assets/about/IMG_5563.jpg';
import galleryImage3 from '../assets/about/11.jpeg';
import galleryImage4 from '../assets/about/13.jpeg';
import galleryImage5 from '../assets/about/Images/16.jpeg';
import galleryImage6 from '../assets/about/Images/25.jpeg';
import galleryImage7 from '../assets/about/Images/27.jpeg';
import galleryImage8 from '../assets/about/Images/36.jpeg';
import galleryImage9 from '../assets/about/Images/43.jpeg';
import galleryImage10 from '../assets/about/Images/5.jpeg';
import galleryImage11 from '../assets/about/jpegmini_optimized/IMG_2096.jpg';
import galleryImage12 from '../assets/about/jpegmini_optimized/IMG_4459.jpg';
import galleryImage13 from '../assets/about/h2.jpeg';
import galleryImage14 from '../assets/about/h21.jpeg';
import galleryImage15 from '../assets/about/m41.jpeg';
import galleryImage16 from '../assets/about/c5.jpeg';
import galleryImage17 from '../assets/about/WhatsApp Image 2025-05-11 at 16.18.35.jpeg';
import galleryImage18 from '../assets/about/WhatsApp Image 2025-05-12 at 07.39.59.jpeg';
import galleryImage20 from '../assets/about/123.jpeg';
import galleryImage21 from '../assets/about/1234.jpeg';
import directorImage from '../assets/about/WhatsApp Image 2025-05-11 at 18.25.44.jpeg';

function About() {
    const galleryImages = [
        { src: galleryImage1, alt: 'Cinnamon spice harvesting' },
        { src: galleryImage2, alt: 'Cinnamon processing facility' },
        { src: galleryImage3, alt: 'Spice export packaging' },
        { src: galleryImage4, alt: 'Cinnamon bark drying' },
        { src: galleryImage5, alt: 'Quality control of spices' },
        { src: galleryImage6, alt: 'Sri Lankan spice market' },
        { src: galleryImage7, alt: 'Cinnamon plantation' },
        { src: galleryImage8, alt: 'Spice export shipment' },
        { src: galleryImage9, alt: 'Traditional spice grinding' },
        { src: galleryImage10, alt: 'Cinnamon product display' },
        { src: galleryImage11, alt: 'Spice farm workers' },
        { src: galleryImage12, alt: 'Global spice trade event' },
        { src: galleryImage13, alt: 'Cinnamon spice harvesting' },
        { src: galleryImage14, alt: 'Cinnamon processing facility' },
        { src: galleryImage15, alt: 'Spice export packaging' },
        { src: galleryImage16, alt: 'Cinnamon bark drying' },
        { src: galleryImage17, alt: 'Quality control of spices' },
        { src: galleryImage18, alt: 'Sri Lankan spice market' },
        { src: galleryImage20, alt: 'Spice export shipment' },
        { src: galleryImage21, alt: 'Traditional spice grinding' },
    ];

    const [selectedImage, setSelectedImage] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);

    const openModal = (image) => {
        setSelectedImage(image);
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
        setSelectedImage(null);
    };

    // Animation variants for sections
    const sectionVariants = {
        hidden: { opacity: 0, scale: 0.95 },
        visible: { opacity: 1, scale: 1, transition: { duration: 0.5 } }
    };

    // Animation variants for gallery images
    const galleryVariants = {
        hidden: { opacity: 0, scale: 0.9 },
        visible: (index) => ({
            opacity: 1,
            scale: 1,
            transition: { duration: 0.6, delay: index * 0.2 }
        })
    };

    // Animation variants for modal
    const modalVariants = {
        hidden: { opacity: 0, scale: 0.8 },
        visible: { opacity: 1, scale: 1, transition: { duration: 0.5 } },
        exit: { opacity: 0, transition: { duration: 0.3 } }
    };

    // SEO Structured Data
    const structuredData = {
        "@context": "https://schema.org",
        "@type": "AboutPage",
        "name": "About Galle Ceylon Spices International",
        "description": "Learn about Galle Ceylon Spices International, a leader in premium Sri Lankan spices since 1990. Discover our history, commitment to quality cinnamon, and sustainable practices from Elpitiya, Sri Lanka.",
        "url": "https://www.galleceylonspices.com/about",
        "publisher": {
            "@type": "Organization",
            "name": "Galle Ceylon Spices International (Pvt) Ltd",
            "logo": {
                "@type": "ImageObject",
                "url": "%PUBLIC_URL%/logo.png"
            },
            "address": {
                "@type": "PostalAddress",
                "streetAddress": "448/2, Nawadagala",
                "addressLocality": "Elpitiya",
                "postalCode": "80000",
                "addressCountry": "Sri Lanka"
            },
            "contactPoint": {
                "@type": "ContactPoint",
                "telephone": "+94-77-929-1829",
                "contactType": "Customer Service",
                "areaServed": "Worldwide",
                "availableLanguage": "English"
            }
        },
        "mainEntity": {
            "@type": "Organization",
            "name": "Galle Ceylon Spices International (Pvt) Ltd",
            "foundingDate": "1990",
            "description": "A leading exporter of premium Ceylon cinnamon and spices, committed to sustainable farming and quality excellence.",
            "subOrganization": {
                "@type": "Organization",
                "name": "Ceylon Spice Essence",
                "description": "A premium brand specializing in organic cinnamon products and innovative spice blends."
            }
        }
    };

    return (
        <div className="container my-4 py-4">
            <SEO
                title="About Galle Ceylon Spices International - Premium Sri Lankan Spices"
                description="Learn about Galle Ceylon Spices International, a leader in premium Sri Lankan spices since 1990. Discover our history, commitment to quality cinnamon, and sustainable practices from Elpitiya, Sri Lanka."
                keywords="Galle Ceylon Spices, Sri Lankan spices, Ceylon cinnamon, Ceylon Spice Essence, organic spices, sustainable farming, Elpitiya Sri Lanka, spice trade history"
                canonicalUrl="https://www.galleceylonspices.com/about"
                ogImage="%PUBLIC_URL%/logo.png"
                structuredData={structuredData}
            />
            {/* About Section */}
            <motion.section
                className="row py-4 rounded-3 shadow-lg"
                style={{
                    backgroundColor: 'rgba(193, 154, 107, 0.1)',
                }}
                initial="hidden"
                animate="visible"
                variants={sectionVariants}
            >
                <div className="col-12 col-md-6 d-flex align-items-center mb-3">
                    <motion.img
                        src={cinnamonImage}
                        alt="Cinnamon spices"
                        className="img-fluid rounded-3 shadow-lg"
                        style={{
                            maxHeight: 'clamp(250px, 40vw, 400px)',
                            objectFit: 'cover',
                            width: '100%',
                        }}
                        whileHover={{ scale: 1.05, boxShadow: '0 8px 20px rgba(193, 154, 107, 0.4)' }}
                        transition={{ duration: 0.3 }}
                    />
                </div>
                <div className="col-12 col-md-6 p-3">
                    <h2
                        className="mb-3 position-relative"
                        style={{
                            fontSize: 'clamp(1.8rem, 4vw, 2.5rem)',
                            color: '#355E3B',
                            fontFamily: 'Georgia',
                            fontWeight: 'bold',
                        }}
                    >
                        Galle Ceylon Spices International (Pvt) Ltd
                        <span
                            className="underline-span"
                            style={{
                                position: 'absolute',
                                bottom: '-8px',
                                left: '0',
                                width: '80px',
                                height: '2px',
                                backgroundColor: '#C19A6B',
                                borderRadius: '2px',
                            }}
                        />
                        <style>
                            {`
            @media (max-width: 576px) {
                .mb-3.position-relative {
                    text-align: center;
                }
                .underline-span {
                    left: 50% !important;
                    transform: translateX(-50%) !important;
                }
            }
        `}
                        </style>
                    </h2>
                    <p
                        style={{
                            fontFamily: 'Georgia',
                            color: '#355E3B',
                            fontSize: 'clamp(0.9rem, 2vw, 1.1rem)',
                            lineHeight: '1.8',
                            marginBottom: '1rem',
                        }}
                    >
                        Founded in 1990, Galle Ceylon Spices International (Pvt) Ltd has been a leader in the spice industry for over three decades. Located at 448/2, near the school in Nawadagala, Elpitiya 80000, Sri Lanka, we have built a reputation for excellence in spice production and trade.
                    </p>
                    <p
                        style={{
                            fontFamily: 'Georgia',
                            color: '#355E3B',
                            fontSize: 'clamp(0.9rem, 2vw, 1.1rem)',
                            lineHeight: '1.8',
                            marginBottom: '1rem',
                        }}
                    >
                        Our flagship product is cinnamon, celebrated for its unparalleled quality and rich aroma. We specialize in cultivating and processing this premium spice, ensuring it meets stringent quality standards for both local and global markets.
                    </p>
                    <p
                        style={{
                            fontFamily: 'Georgia',
                            color: '#355E3B',
                            fontSize: 'clamp(0.9rem, 2vw, 1.1rem)',
                            lineHeight: '1.8',
                        }}
                    >
                        As a proud exporter, we bring the authentic flavors of Sri Lankan spices to customers worldwide. Our commitment to sustainable practices and customer satisfaction has made us a trusted name in the international spice trade.
                    </p>
                    <style>
                        {`
        @media (max-width: 576px) {
            p {
                text-align: center;
            }
        }
    `}
                    </style>
                </div>
            </motion.section>

            {/* Cinnamon Magic Section */}
            <motion.section
                className="row py-4 mt-4 rounded-3 shadow-lg"
                style={{
                    backgroundColor: 'rgba(193, 154, 107, 0.1)',
                }}
                initial="hidden"
                animate="visible"
                variants={sectionVariants}
            >
                <div className="col-12 col-md-6 order-md-2 d-flex align-items-center mb-3">
                    <motion.img
                        src={cinnamonImage2}
                        alt="Cinnamon Magic"
                        className="img-fluid rounded-3 shadow-lg"
                        style={{
                            maxHeight: 'clamp(250px, 40vw, 400px)',
                            objectFit: 'cover',
                            width: '100%',
                        }}
                        whileHover={{ scale: 1.05, boxShadow: '0 8px 20px rgba(193, 154, 107, 0.4)' }}
                        transition={{ duration: 0.3 }}
                    />
                </div>
                <div className="col-12 col-md-6 order-md-1 p-3">
                    <h2
                        className="mb-3 position-relative"
                        style={{
                            fontSize: 'clamp(1.8rem, 4vw, 2.5rem)',
                            color: '#355E3B',
                            fontFamily: 'Georgia',
                            fontWeight: 'bold',
                        }}
                    >
                        Cinnamon Magic
                        <span
                            className="underline-span"
                            style={{
                                position: 'absolute',
                                bottom: '-8px',
                                left: '0',
                                width: '80px',
                                height: '2px',
                                backgroundColor: '#C19A6B',
                                borderRadius: '2px',
                            }}
                        />
                        <style>
                            {`
            @media (max-width: 576px) {
                .underline-span {
                    left: 50% !important;
                    transform: translateX(-50%) !important;
                }
            }
        `}
                        </style>
                    </h2>
                    <p
                        style={{
                            fontFamily: 'Georgia',
                            color: '#355E3B',
                            fontSize: 'clamp(0.9rem, 2vw, 1.1rem)',
                            lineHeight: '1.8',
                            marginBottom: '1rem',
                        }}
                    >
                        Introducing Ceylon Spice Essence, a premium sister brand of Galle Ceylon Spices International (Pvt) Ltd. Launched to cater to the growing demand for high-quality, authentic cinnamon products, this brand embodies the rich heritage and craftsmanship of Sri Lanka’s spice trade.
                    </p>
                    <p
                        style={{
                            fontFamily: 'Georgia',
                            color: '#355E3B',
                            fontSize: 'clamp(0.9rem, 2vw, 1.1rem)',
                            lineHeight: '1.8',
                            marginBottom: '1rem',
                        }}
                    >
                        Ceylon Spice Essence specializes in organic cinnamon sticks, powders, and innovative blends, crafted with sustainable farming techniques. Each product is rigorously tested to ensure purity and flavor, appealing to health-conscious consumers worldwide.
                    </p>
                    <p
                        style={{
                            fontFamily: 'Georgia',
                            color: '#355E3B',
                            fontSize: 'clamp(0.9rem, 2vw, 1.1rem)',
                            lineHeight: '1.8',
                        }}
                    >
                        With a strong presence in over 50 countries, Ceylon Spice Essence continues to uphold our legacy of excellence. Our commitment to eco-friendly practices and community support ensures a sustainable future for this magical spice.
                    </p>
                </div>
            </motion.section>

            {/* Director's Vision & Mission Section */}
            <motion.section
                className="row py-4 mt-4 rounded-3 shadow-lg"
                style={{
                    backgroundColor: 'rgba(193, 154, 107, 0.1)',
                }}
                initial="hidden"
                animate="visible"
                variants={sectionVariants}
            >
                <div className="col-12 col-md-6 d-flex align-items-center mb-3">
                    <motion.img
                        src={directorImage}
                        alt="Director of Galle Ceylon Spices"
                        className="img-fluid rounded-3 shadow-lg"
                        style={{
                            maxHeight: 'clamp(550px, 60vw, 400px)',
                            objectFit: 'cover',
                            width: '100%',
                        }}
                        whileHover={{ scale: 1.05, boxShadow: '0 8px 20px rgba(193, 154, 107, 0.4)' }}
                        transition={{ duration: 0.3 }}
                    />
                </div>
                <div className="col-12 col-md-6 p-3">
                    <h2
                        className="mb-3 position-relative"
                        style={{
                            fontSize: 'clamp(1.8rem, 4vw, 2.5rem)',
                            color: '#355E3B',
                            fontFamily: 'Georgia',
                            fontWeight: 'bold',
                        }}
                    >
                        Director's Vision & Mission
                        <span
                            className="underline-span"
                            style={{
                                position: 'absolute',
                                bottom: '-8px',
                                left: '0',
                                width: '80px',
                                height: '2px',
                                backgroundColor: '#C19A6B',
                                borderRadius: '2px',
                            }}
                        />
                        <style>
                            {`
            @media (max-width: 576px) {
                .mb-3.position-relative {
                    text-align: center;
                }
                .underline-span {
                    left: 50% !important;
                    transform: translateX(-50%) !important;
                }
            }
        `}
                        </style>
                    </h2>
                    <p
                        style={{
                            fontFamily: 'Georgia',
                            color: '#355E3B',
                            fontSize: 'clamp(0.9rem, 2vw, 1.1rem)',
                            lineHeight: '1.8',
                            marginBottom: '1rem',
                        }}
                    >
                        Our director envisions Galle Ceylon Spices International as a global leader in delivering the finest quality spices, with a steadfast commitment to excellence. By prioritizing sustainable sourcing and rigorous quality control, we ensure that every product reflects the rich heritage of Sri Lankan spices while meeting the highest international standards.
                    </p>
                    <p
                        style={{
                            fontFamily: 'Georgia',
                            color: '#355E3B',
                            fontSize: 'clamp(0.9rem, 2vw, 1.1rem)',
                            lineHeight: '1.8',
                        }}
                    >
                        The mission is to foster a nurturing environment for our dedicated staff members, empowering them to grow and innovate. Through strong community partnerships and a focus on ethical practices, we aim to create a lasting impact, ensuring that our spices not only delight customers but also contribute positively to the world.
                    </p>
                    <style>
                        {`
        @media (max-width: 576px) {
            p {
                text-align: center;
            }
        }
    `}
                    </style>
                </div>
            </motion.section>

            {/* Gallery Section */}
            <motion.section
                style={{
                    marginTop: '2rem',
                }}
                initial="hidden"
                animate="visible"
                variants={sectionVariants}
            >
                <h2
                    className="text-center mb-4 position-relative"
                    style={{
                        fontSize: 'clamp(1.8rem, 4vw, 2.5rem)',
                        color: '#355E3B',
                        fontFamily: 'Georgia',
                        fontWeight: 'bold',
                    }}
                >
                    Gallery
                    <span
                        style={{
                            position: 'absolute',
                            bottom: '-8px',
                            left: '50%',
                            transform: 'translateX(-50%)',
                            width: '80px',
                            height: '2px',
                            backgroundColor: '#C19A6B',
                            borderRadius: '2px',
                        }}
                    />
                </h2>
                <div className="row g-3">
                    {galleryImages.map((image, index) => (
                        <motion.div
                            key={index}
                            className="col-12 col-sm-6 col-md-4 col-lg-3"
                            custom={index}
                            initial="hidden"
                            animate="visible"
                            variants={galleryVariants}
                        >
                            <motion.img
                                src={image.src}
                                alt={image.alt}
                                className="img-fluid rounded-3 shadow-lg"
                                style={{
                                    objectFit: 'cover',
                                    width: '100%',
                                    height: 'clamp(250px, 30vw, 250px)',
                                    border: '1px solid transparent',
                                    cursor: 'pointer',
                                }}
                                whileHover={{
                                    scale: 1.05,
                                    boxShadow: '0 10px 25px rgba(193, 154, 107, 0.5)',
                                    border: '1px solid #C19A6B'
                                }}
                                transition={{ duration: 0.3 }}
                                onClick={() => openModal(image)}
                            />
                        </motion.div>
                    ))}
                </div>

                {/* Modal for Full-Screen Image */}
                <AnimatePresence>
                    {isModalOpen && (
                        <motion.div
                            className="modal"
                            style={{
                                position: 'fixed',
                                top: 0,
                                left: 0,
                                width: '100%',
                                height: '100%',
                                background: 'rgba(0, 0, 0, 0.8)',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                zIndex: 1000,
                            }}
                            initial="hidden"
                            animate="visible"
                            exit="exit"
                            variants={modalVariants}
                            onClick={closeModal}
                        >
                            <motion.div
                                style={{
                                    position: 'relative',
                                    maxWidth: '80%',
                                    maxHeight: '90vh',
                                }}
                                onClick={(e) => e.stopPropagation()}
                            >
                                <motion.img
                                    src={selectedImage?.src}
                                    alt={selectedImage?.alt}
                                    style={{
                                        maxWidth: '100%',
                                        maxHeight: '90vh',
                                        borderRadius: '8px',
                                        boxShadow: '0 12px 30px rgba(193, 154, 107, 0.6)',
                                        objectFit: 'contain',
                                    }}
                                />
                                <motion.button
                                    onClick={closeModal}
                                    style={{
                                        position: 'absolute',
                                        top: '-35px',
                                        right: '-35px',
                                        backgroundColor: '#C19A6B',
                                        border: 'none',
                                        color: '#FFFFFF',
                                        width: 'clamp(30px, 5vw, 40px)',
                                        height: 'clamp(30px, 5vw, 40px)',
                                        borderRadius: '50%',
                                        fontSize: 'clamp(1.2rem, 2.5vw, 1.5rem)',
                                        cursor: 'pointer',
                                    }}
                                    whileHover={{ backgroundColor: '#A67B4D', scale: 1.1 }}
                                    transition={{ duration: 0.3 }}
                                >
                                    ×
                                </motion.button>
                            </motion.div>
                        </motion.div>
                    )}
                </AnimatePresence>
            </motion.section>
        </div>
    );
}

export default About;